import { all, fork, call, put, takeEvery, CallEffect, PutEffect } from "redux-saga/effects";
import { ActionTypes } from "../../constants/ActionTypes";
import { ShowError, ShowSuccess } from "../../helper/Alert";
import { goBack } from "connected-react-router";
import { onGetFastSignSuccess } from "../actions";
import faMessage from "../../../src/lngProvider/locales/fa_IR.json";
import enMessage from "../../../src/lngProvider/locales/en_US.json";
import { defineMessages } from "react-intl";
import FaraGostarDynamicHttp from "../../api/FaraGostarDynamicHttp";
import { AxiosResponse } from "axios";
import { IEmployeePositionFastSignature } from "../../interfaces";

// fastSign
const fastSignApi = async (
    employeePositionSignatureId: number,
    letterCode: string[],
    singnIndex: number) => {
    let http = await FaraGostarDynamicHttp();
    return await http.post(`sign/FastSign`, {
        employeePositionFastSignatureId: employeePositionSignatureId,
        letterCodes: letterCode,
        signIndex: singnIndex
    });
}

const getFastSignatureApi = async (
    secretariatToSecretariatFormatId: number,
    signIndex: number) => {
    let http = await FaraGostarDynamicHttp();
    return await http.get(`sign/GetFastSignutares?secretariatToSecretariatFormatId=${secretariatToSecretariatFormatId}&signIndex=${signIndex}`);
}

function* fastSignRequest(action: any) {
    const LocaleMessages = localStorage.getItem("language") === 'fa-IR' ? faMessage : enMessage;
    const messages = defineMessages(LocaleMessages);
    try {
        yield call(fastSignApi,
            action.payload.employeePositionFastSignatureId,
            action.payload.letterCodes,
            action.payload.signIndex);
        ShowSuccess("", messages["draft.SignLetter"]);
        yield put(goBack())
    } catch (error) {
        ShowError("", error);
    }
}

export function* fastSign() {
    yield takeEvery(ActionTypes.FAST_SIGN, fastSignRequest);
}

function* fetchFastSignatureListRequest(action: any): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, void, IEmployeePositionFastSignature[]> {
    try {
        const signatureResponse = yield call(getFastSignatureApi, action.payload.secretariatToSecretariatFormatId, action.payload.signIndex);
        yield put(onGetFastSignSuccess(signatureResponse));
    } catch (error) {
        return ShowError("", error);
    }
}

export function* fetchFastSignatureList() {
    yield takeEvery(ActionTypes.GET_FAST_SING, fetchFastSignatureListRequest);
}

export default function* rootSaga() {
    yield all([fork(fastSign), fork(fetchFastSignatureList)]);
}
